<div *ngIf="isLoggedIn" class="flex items-center">

  <!--
  <div *ngIf="loading$ | async; else content" class="bg-secondary text-primary-100 text-sm rounded-md px-6 py-2 mr-6">
    Loading...
  </div>
  -->

  <!-- ng-template #content -->

  <div *ngIf="error$ | async as error" class="bg-secondary text-primary-100 text-sm rounded-md px-6 py-2 mr-6">
    Error: {{ error.message }}
  </div>
  <div class="flex items-center bg-secondary tracking-wide rounded-md px-6 py-2 mr-6 transition-container">
    <!--
    {{ credits$ | async }}
    -->
    <div class="flex items-end">
      <span class="text-primary-100 text-sm font-medium credits-number pr-1" [ngClass]="{ 'fade-animation': isFading }">
        {{ currentCredits }}
      </span>
      <span class="text-[12px] text-white font-medium">Credits</span>
    </div>
  </div>
  <div class="bg-secondary text-primary-100 text-sm rounded-md px-6 py-2 mr-6 hidden">
    AI Tokens: {{ aiTokens$ | async }}
  </div>

</div>
